module.exports = __webpack_public_path__ + "img/Sunny-sensei.3edafaa1.jpg";